import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class IrisProtocolService {
  private readonly _httpClient = inject(HttpClient);

  public unlock(protocolId: number, userId: number): Observable<void> {
    return this._httpClient.get<void>(
      `/shift/protocol/${protocolId}/unlock`,
      { params: { userId: userId.toString() } });
  }

  public rejectUnlock(protocolId: number, userId: number): Observable<void> {
    return this._httpClient.get<void>(
      `/shift/protocol/${protocolId}/reject-unlock`,
      { params: { userId: userId.toString() } });
  }
}
